import type { JSX } from 'react';

/*  LE ICONE DELL'APPLICATIVO, disegnate qui.

    Nate il 20/09/2026 sistemando i comandi di riga del preventivo. Erano caratteri:
    frecce, e in mezzo alle frecce tre emoji — 🤝 per il subappalto, 👁 per la stampa,
    🔒 per il costo bloccato. Il difetto non era il gusto: **le emoji le disegna il
    sistema operativo**, a colori, con il suo peso e la sua dimensione, e in una fila di
    dieci comandi grigi alti dodici pixel ne uscivano tre colorati che sembravano avvisi.
    Su un Mac o su Android sarebbero stati tre disegni ancora diversi.

    Adesso sono tutte SVG con lo stesso tratto, che prendono il colore da chi le contiene
    (`currentColor`): un comando spento e' grigio, uno acceso e' blu, e non c'e' niente da
    sapere in piu'.

    Perche' non una libreria di icone: sono venti disegni di quattro righe l'uno, e una
    dipendenza va aggiornata, controllata, e porta dentro le altre duemila che non usiamo.

    Le regole del disegno, per chi ne aggiunge una: riquadro 24x24, solo tracciati
    (`fill="none"`), spessore 1,6 — a 15 pixel l'1,5 sparisce e il 2 impasta — estremi
    tondi, e niente dettagli piu' piccoli di due unita', che a quella misura diventano
    una macchia.
*/

const DISEGNI = {
  // ---- comandi di riga: costruire ----
  'inserisci-sopra': (
    <>
      <path d="M4 6h16" />
      <path d="M12 20v-8" />
      <path d="M8.5 15.5 12 12l3.5 3.5" />
    </>
  ),
  'inserisci-sotto': (
    <>
      <path d="M4 18h16" />
      <path d="M12 4v8" />
      <path d="M8.5 8.5 12 12l3.5-3.5" />
    </>
  ),
  /*  La riga vuota e' uno stacco fra due blocchi, e il disegno lo dice cosi': la linea
      tratteggiata e' il posto che resta vuoto, la freccia dice che va sotto.  */
  'riga-vuota': (
    <>
      <path d="M12 3v7" />
      <path d="M9 7.5 12 10.5l3-3" />
      <path d="M4 16h3.5M10.25 16h3.5M16.5 16h3.5" />
    </>
  ),
  'aggiungi-dentro': (
    <>
      <path d="M5 4v10a2 2 0 0 0 2 2h8" />
      <path d="M12.5 12.5 16 16l-3.5 3.5" />
      <path d="M18 4v5M15.5 6.5h5" />
    </>
  ),

  // ---- comandi di riga: correggere ----
  su: (
    <>
      <path d="M12 19V5" />
      <path d="M6 11l6-6 6 6" />
    </>
  ),
  giu: (
    <>
      <path d="M12 5v14" />
      <path d="M6 13l6 6 6-6" />
    </>
  ),
  /*  Uscire dal capitolo e rientrarci: la sbarra verticale e' il bordo del capitolo, la
      freccia dice da che parte si va. Sono l'una lo specchio dell'altra, ed e' voluto —
      due comandi opposti devono avere due disegni opposti, non due disegni diversi.  */
  esci: (
    <>
      <path d="M4 5v14" />
      <path d="M21 12H9" />
      <path d="M13 8l-4 4 4 4" />
    </>
  ),
  entra: (
    <>
      <path d="M20 5v14" />
      <path d="M3 12h12" />
      <path d="M11 8l4 4-4 4" />
    </>
  ),

  /*  Aprire e chiudere un capitolo (15/10/2026): la punta in giu' dice «e' aperto, sotto
      c'e' roba», quella a destra «c'e' altro dentro, chiuso».  */
  'capitolo-aperto': <path d="M6 9l6 6 6-6" />,
  'capitolo-chiuso': <path d="M9 6l6 6-6 6" />,
  /*  Il carrello personale (15/10/2026): il cestino con le due ruote, come in ogni
      negozio — e' il segno che chiunque riconosce per «metto da parte per dopo».  */
  /*  La campanella degli avvisi (16/10/2026).  */
  campanella: (
    <>
      <path d="M6 16V11a6 6 0 0 1 12 0v5l1.5 2h-15L6 16Z" />
      <path d="M10 20.5a2 2 0 0 0 4 0" />
    </>
  ),
  carrello: (
    <>
      <path d="M3 4h2l2.2 10.2a1 1 0 0 0 1 .8h8.6a1 1 0 0 0 1-.76L19.5 8H6.2" />
      <circle cx="9.5" cy="19" r="1.3" />
      <circle cx="16.5" cy="19" r="1.3" />
    </>
  ),

  // ---- comandi di riga: stati della riga ----
  /*  Il subappalto e' «questa voce la fa un altro»: la freccia che esce dal riquadro e'
      il disegno che tutti conoscono per «va fuori».  */
  subappalto: (
    <>
      <path d="M11 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5" />
      <path d="M14.5 9.5 20 4" />
      <path d="M15 4h5v5" />
    </>
  ),
  visibile: (
    <>
      <path d="M2.5 12S6 6 12 6s9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z" />
      <circle cx="12" cy="12" r="2.5" />
    </>
  ),
  nascosto: (
    <>
      <path d="M9.9 5.2A9.6 9.6 0 0 1 12 5c6 0 9.5 7 9.5 7a17 17 0 0 1-3 3.8" />
      <path d="M6.3 7.3A17 17 0 0 0 2.5 12S6 19 12 19a9.4 9.4 0 0 0 3.8-.8" />
      <path d="M3 3l18 18" />
    </>
  ),
  bloccato: (
    <>
      <rect x="4.5" y="10.5" width="15" height="9.5" rx="2" />
      <path d="M8 10.5V7.5a4 4 0 0 1 8 0v3" />
    </>
  ),
  sbloccato: (
    <>
      <rect x="4.5" y="10.5" width="15" height="9.5" rx="2" />
      <path d="M8 10.5V7.5a4 4 0 0 1 7.6-1.7" />
    </>
  ),
  copia: (
    <>
      <rect x="9" y="9" width="11" height="11" rx="2" />
      <path d="M5 15H4.5A2 2 0 0 1 2.5 13V4.5a2 2 0 0 1 2-2H13a2 2 0 0 1 2 2V5" />
    </>
  ),
  /*  Meno e piu' del contatore delle ore, sul telefono. Come icone e non come caratteri
      perche' il «−» vero (U+2212) e il trattino che quasi tutti scrivono al suo posto
      hanno larghezze diverse, e i due bottoni del contatore uscivano storti.  */
  meno: <path d="M5 12h14" />,
  piu: (
    <>
      <path d="M5 12h14" />
      <path d="M12 5v14" />
    </>
  ),
  /*  La «i» che dice «qui c'e' da dove esce questo numero». Cerchio e asta separati, e
      il punto e' un tratto di lunghezza zero con l'estremo tondo: a quindici pixel un
      cerchietto pieno da due unita' diventa una macchia.  */
  info: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 16v-4.5" />
      <path d="M12 8.2h.01" />
    </>
  ),
  rimuovi: (
    <>
      <path d="M6 6l12 12" />
      <path d="M18 6 6 18" />
    </>
  ),
  chiudi: (
    <>
      <path d="M6 6l12 12" />
      <path d="M18 6 6 18" />
    </>
  ),

  // ---- le macroaree della pagina iniziale ----
  preventivazione: (
    <>
      <path d="M6 2.5h8l4 4v15H6z" />
      <path d="M14 2.5v4h4" />
      <path d="M9 12h6M9 16h6" />
    </>
  ),
  commesse: (
    <>
      <path d="M3 21h18" />
      <path d="M5 21V8.5L12 3l7 5.5V21" />
      <path d="M10 21v-6h4v6" />
    </>
  ),
  acquisti: (
    <>
      <path d="M3 7.5l9-4.5 9 4.5v9L12 21l-9-4.5z" />
      <path d="M3 7.5l9 4.5 9-4.5" />
      <path d="M12 12v9" />
    </>
  ),
  anagrafiche: (
    <>
      <rect x="3" y="4.5" width="18" height="15" rx="2" />
      <path d="M3 9h18" />
      <path d="M7 13h4M7 16h8" />
    </>
  ),
  assistenza: (
    <>
      <path d="M12 21c-3.9 0-6.5-2.6-6.5-6.2 0-3.4 2.6-5.6 4.1-8.8.4 1.9 1.3 3 2.4 3.6.2-2.8 1.4-5.2 3.4-6.6-.3 2.9.6 5 1.9 6.9 1 1.5 1.7 3 1.7 4.9 0 3.6-3.1 6.2-7 6.2z" />
      <path d="M12 21c-1.7 0-2.8-1.2-2.8-2.7 0-1.6 1.3-2.6 2.8-4.3 1.5 1.7 2.8 2.7 2.8 4.3 0 1.5-1.1 2.7-2.8 2.7z" />
    </>
  ),
  contabilita: (
    <>
      <rect x="5" y="2.5" width="14" height="19" rx="2" />
      <path d="M8.5 7h7" />
      <path d="M9 12h.01M12 12h.01M15 12h.01M9 16.5h.01M12 16.5h.01M15 16.5h.01" />
    </>
  ),
  parametri: (
    <>
      <path d="M3.5 7h4M12 7h8.5" />
      <circle cx="9.75" cy="7" r="2.25" />
      <path d="M3.5 12h10M17.5 12h3" />
      <circle cx="15.25" cy="12" r="2.25" />
      <path d="M3.5 17h2M10 17h10.5" />
      <circle cx="7.75" cy="17" r="2.25" />
    </>
  ),
} satisfies Record<string, JSX.Element>;

export type NomeIcona = keyof typeof DISEGNI;

/*  `aria-hidden` sempre: l'icona non dice niente a chi non la vede, e il significato sta
    nell'`aria-label` del bottone che la contiene. Un'icona che si annuncia da sola
    leggerebbe due volte la stessa cosa, o peggio una cosa diversa.

    La misura la decide il CSS e non un attributo: la stessa icona sta a 15px in una riga
    di preventivo e a 23px su un riquadro della pagina iniziale.  */
export function Icona({ nome }: { nome: NomeIcona }) {
  return (
    <svg
      className="icona"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {DISEGNI[nome]}
    </svg>
  );
}
